// Smooth Scroll Polyfill
// https://github.com/iamdustan/smoothscroll
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

// Promise Defer Polyfill
// http://bluebirdjs.com/docs/api/deferred-migration.html
if (window.Promise && !window.Promise.defer) {
  Promise.defer = function defer() {
    let resolve, reject;

    const promise = new Promise((_resolve, _reject) => {
      resolve = _resolve;
      reject = _reject;
    });

    return {
      resolve,
      reject,
      promise,
    };
  }
}

// Console Debug (IE 10)
if (window.console && !window.console.debug) {
  window.console.debug = window.console.log;
}

// NodeList.forEach
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

// NodeList.reduce
if (window.NodeList && !NodeList.prototype.reduce) {
  NodeList.prototype.reduce = Array.prototype.reduce;
}

if (!HTMLElement.prototype.remove) {
  HTMLElement.prototype.remove = function remove() {
    this.parentNode.removeChild(this);
  };
}

if (!HTMLElement.prototype.hasClass) {
  HTMLElement.prototype.hasClass = function hasClass(className) {
    return this.classList.contains(className);
  };
}

if (!HTMLElement.prototype.addClass) {
  HTMLElement.prototype.addClass = function addClass(className) {
    if (this.hasClass(className)) {
      return this;
    }

    this.classList.add(className);
    return this;
  };
}

if (!HTMLElement.prototype.removeClass) {
  HTMLElement.prototype.removeClass = function removeClass(className) {
    if (!this.hasClass(className)) {
      return this;
    }

    this.classList.remove(className);
    return this;
  };
}

if (!HTMLElement.prototype.toggleClass) {
  HTMLElement.prototype.toggleClass = function toggleClass(className, state) {
    this.classList.toggle(className, state);
  };
}
